import { render } from "./EditCourtDialog.vue?vue&type=template&id=4c083385"
import script from "./EditCourtDialog.vue?vue&type=script&lang=js"
export * from "./EditCourtDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__